import { debounce, some } from 'lodash'
import slideApi from '@/api/slide'
import { PARTICIPANT_SELECTED_FIELDS } from '@/vuex/modules/presentation/setting.module'

let debouncedUpdateParticipantField = null
// ALL THE SLIDE TYPES THAT SUPPORT COLLECT PARTICIPANT INFO
const COLLECT_INFO_SLIDE_TYPES = [
  'openEnded', 'ideas',
]

const SET_SLIDE_ACTIVE = 'setSlideActive'

const _state = {
  [PARTICIPANT_SELECTED_FIELDS]: [],
}

const checkShowCollectInfor = (slide, rootGetters) => {
  if (rootGetters['slidePlugin/canUseSlidePlugin'] &&
    rootGetters['slidePlugin/slideActiveConfig'].plugin &&
    rootGetters['slidePlugin/slideActiveConfig'].setting.enableAdditionalFieldsSetting) return true
  return COLLECT_INFO_SLIDE_TYPES.includes(slide?.type)
}

const actions = {
  getSelectedParticipantFields: async ({ commit }, slideId) => {
    if (!slideId) return Promise.resolve()
    const res = await slideApi.getSelectedParticipantFields(slideId)
    commit('setSelectedParticipantFields', res[PARTICIPANT_SELECTED_FIELDS] || [])
    return res
  },
  unsetSelectedParticipantFields: async ({ commit }) => {
    commit('setSelectedParticipantFields', [])
  },
  updateSelectedParticipantFields: async ({ commit }, { slideId, fields }) => {
    // update code go here
    // Update local slide active state
    commit('setSelectedParticipantFields', fields)

    // Call Api
    if (!debouncedUpdateParticipantField) {
      debouncedUpdateParticipantField = debounce(
        // We need to bind everytime, otherwise, it will catch the wrong value
        // eslint-disable-next-line no-shadow
        (slideId, fields) => {
          slideApi.updateSelectedParticipantFields(slideId, {
            selectedParticipantFields: fields,
          })
        },
        300,
      )
    }

    return debouncedUpdateParticipantField(slideId, fields)
  },
  deleteSlideParticipantField: async ({ getters, commit, rootGetters }, { slide, fieldId }) => {
    if (!slide.id || !checkShowCollectInfor(slide, rootGetters)) return
    // Update the current state
    const { selectedFields } = getters
    commit('setSelectedParticipantFields', selectedFields.filter((f) => f.id !== fieldId))

    // Update Participant Fields for all slides
    const { selectedParticipantFields } = await slideApi.getSelectedParticipantFields(slide.id)

    if (!selectedParticipantFields || !selectedParticipantFields.length) return
    const updatedFields = selectedParticipantFields?.filter((f) => f.id !== fieldId)

    slideApi.updateSelectedParticipantFields(slide.id, {
      selectedParticipantFields: updatedFields,
    })
  },
}

const _getters = {
  selectedFields: (state) => {
    return state[PARTICIPANT_SELECTED_FIELDS]
  },
  selectedParticipantFields: (_, getters, ___, rootGetters) => {
    const participantFields = rootGetters['presentationSetting/participantFields']

    return getters.selectedFields?.map(({ id, required, hidden }) => {
      const fieldData = participantFields?.find(({ id: fieldId }) => fieldId === id)
      return {
        ...fieldData,
        id,
        required,
        hidden,
      }
    })
  },
  isShowingParticipantInfo: (_, getters, ___, rootGetters) => {
    const slideActive = rootGetters['slideModule/slideActive']
    if (slideActive.type === 'ideas') return true

    const hasFields = getters.selectedFields.length > 0
    const hasShownItem = some(getters.selectedFields, (field) => !field.hidden)

    return hasFields && hasShownItem
  },
}

const _mutations = {
  setSelectedParticipantFields(state, payload) {
    state[PARTICIPANT_SELECTED_FIELDS] = payload
  },
}

const plugin = (store) => {
  store.subscribe(async (mutation, state) => {
    // Your code to execute after a mutation
    if (mutation.type !== SET_SLIDE_ACTIVE) return
    const { slideActive } = state
    if (!slideActive || !checkShowCollectInfor(slideActive, store.getters)) return
    await store.dispatch('slideSettingModule/unsetSelectedParticipantFields')
    store.dispatch('slideSettingModule/getSelectedParticipantFields', slideActive.id)
  })
}

export default {
  namespaced: true,
  actions,
  mutations: _mutations,
  state: _state,
  getters: _getters,
  plugin,
}
